/**
 * Subscribe to the sync engine's observable status.
 *
 * `useState` + `subscribe`, not `useSyncExternalStore`: `SyncEngine.getStatus()`
 * returns a fresh object on every call, which `useSyncExternalStore` would
 * compare with Object.is and re-render on forever. `subscribe` already delivers
 * the current snapshot immediately, so there is no initial-value gap either.
 */

import { useEffect, useState } from 'react';

import type { SyncEngine, SyncStatus } from '../../db/sync';

export function useSyncStatus(engine: SyncEngine): SyncStatus {
  const [status, setStatus] = useState<SyncStatus>(() => engine.getStatus());

  useEffect(() => {
    // `subscribe` invokes the listener once with the current status, so a
    // change that landed between render and effect is not missed.
    return engine.subscribe(setStatus);
  }, [engine]);

  return status;
}
